export default __webpack_public_path__ + "static/media/avatar_ali8.85126810.mp3";